var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FCE8E9",
    width: 32,
    height: 32,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.91 7.066c-.9 0-1.637.737-1.637 1.636 0 1.179.693 2.747 1.426 4.205-.581 1.822-1.242 3.794-2.102 5.454h-.006c-1.71.674-3.23 1.182-4.091 1.875-.344.304-.494.815-.5 1.193 0 .9.737 1.637 1.636 1.637.474 0 .912-.215 1.188-.494.647-.773 2.163-3.578 2.165-3.58 1.656-.652 3.404-1.323 5.096-1.716 1.15.953 2.898 1.608 4.279 1.608.9 0 1.636-.737 1.636-1.636 0-.9-.737-1.637-1.636-1.637-1.118 0-2.837.42-4.097.853-1.083-1-2.08-2.266-2.784-3.614.488-1.518 1.062-3.044 1.062-4.148 0-.9-.736-1.636-1.636-1.636Zm0 .727c.505 0 .908.403.908.91 0 .682-.379 1.891-.784 3.153C14.476 10.642 14 9.42 14 8.702c0-.506.403-.909.91-.909Zm.266 5.966a14.347 14.347 0 0 0 2.29 2.932c-1.318.34-2.62.817-3.886 1.307.638-1.364 1.139-2.826 1.596-4.239Zm7.188 2.58c.506 0 .909.402.909.909 0 .506-.403.909-.91.909-.982 0-2.35-.484-3.352-1.137 1.157-.355 2.545-.681 3.353-.681Zm-10.444 3.08c-.592 1.083-1.212 2.147-1.647 2.67a.878.878 0 0 1-.637.25.904.904 0 0 1-.909-.91c0-.24.104-.478.25-.636.525-.415 1.659-.871 2.943-1.375Z",
    fill: "#F00421",
    fillRule: "nonzero"
  }))));
};
export { SvgPdf as ReactComponent };
export default __webpack_public_path__ + "f3821dfa975c7809a9cca994125a03eb.svg";